export default {
  description: `#### NEW ARRIVALS TO MAKE THEM JUMP, JUMP!`,
  links: [
    {
      text: 'SHOP GIRLS',
      destination: 'https://www.example.com',
      images: {
        0: 'https://via.placeholder.com/127x190',
        200: 'https://via.placeholder.com/280x426'
      }
    },
    {
      text: 'SHOP BOYS',
      destination: 'https://www.example.com',
      images: {
        0: 'https://via.placeholder.com/127x190',
        200: 'https://via.placeholder.com/280x426'
      }
    }
  ]
}



// WEBPACK FOOTER //
// ./src/modules/touts/splitTout/defaultProps.base.js